import React from "react";
import { Flex } from "/app/src/component";
import style from "./style.css";
import Jibber from "/app/src/jibber";

// if props manual is declare, we dont change active state auto but ask for it from
// parent

/*
    props
        - on
        - manual
        - colorOn: default green
        - colorOff: default red
        - (Maybe more)
*/

class ToogleSwitch extends Jibber {
  constructor(props) {
    super(props);
    this._handleClick = this._handleClick.bind(this);
    this.useState({
      clickOnDisable: false,
    });
  }

  _handleClick(event) {
    const { disable, on } = this.props;
    if (disable) {
      this.setClickOnDisable(true);
      return false;
    }
    event.target.value = !on;
    this.props.onChange(event);
  }

  render() {
    var {
      on: on = false,
      colorOn: colorOn = "#8fef54",
      colorOff: colorOff = "lightgrey",
      disable: disable = false,
      disableReason: disableReason = "If you going to use disable, a reason should be provide",
      ...rest
    } = this.props;
    const { clickOnDisable } = this.state;

    const bgColor = on ? colorOn : colorOff;

    return (
      <Flex
        height="30px"
        onClick={this._handleClick}
        position="relative"
        {...rest}
      >
        <label className={style.switch}>
          <input disabled type="checkbox" checked={this.props.on} />
          <span
            style={{ backgroundColor: bgColor }}
            className={style.slider}
          ></span>
        </label>
        <Flex
          position="absolute"
          color="red"
          fontSize="12px"
          width="100px"
          bottom="-20px"
        >
          {disable && clickOnDisable && disableReason}
        </Flex>
      </Flex>
    );
  }
}
export default ToogleSwitch;



// WEBPACK FOOTER //
// ./src/component/Forms/ToogleSwitch/index.js